import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ValidationIssue, ValidationIssueReason } from 'src/app/services/report-template-validation.service';

const VALIDATION_ISSUE_TRANSLATION_KEYS: Record<ValidationIssueReason, string> = {
  [ValidationIssueReason.UnresolvedRaw]: 'Unresolved placeholder: [[{{path}}]]',
  [ValidationIssueReason.ChipMissingField]: 'Field not found: {{path}}',
  [ValidationIssueReason.StructuralAttrUnresolved]: 'Unresolved loop/conditional expression: {{path}}',
  [ValidationIssueReason.HeaderLoopWithoutBodyLoop]: 'Table has a header loop column but no matching body loop row'
};

@Component({
    standalone: true,
    selector: 'app-validation-banner',
    imports: [SharedModule],
    templateUrl: './validation-banner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./validation-banner.component.scss']
})
export class ValidationBannerComponent implements OnChanges {
  @Input() issues: ValidationIssue[] = [];

  isExpanded = true;
  issueLabels = new Map<string, string>();

  constructor(private translate: TranslateService) {}

  get hasIssues(): boolean {
    return this.issues.length > 0;
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['issues']) {
      this.issueLabels = new Map(
        this.issues.map(issue => [
          this.trackByPath(0, issue),
          this.translate.instant(VALIDATION_ISSUE_TRANSLATION_KEYS[issue.reason], { path: issue.path })
        ])
      );
    }
  }

  trackByPath(_: number, issue: ValidationIssue): string {
    return `${issue.path}::${issue.reason}`;
  }
}
